import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    // Content is visible by default. Only when we can actually animate do we
    // arm the hidden state (.is-reveal-ready gates the opacity:0 in CSS), so a
    // JS-disabled or pre-hydration page never renders blank.
    if (reduce || !("IntersectionObserver" in window)) return
    this.element.classList.add("is-reveal-ready")

    // 1) One-shot reveal — unobserve after the element has appeared.
    this.io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("is-in"); this.io.unobserve(e.target) }
      }),
      { rootMargin: "0px 0px -10% 0px", threshold: 0.12 }
    )
    this.element.querySelectorAll("[data-reveal]").forEach((el) => this.io.observe(el))

    // 2) Looping animations — keep observing so they PAUSE when scrolled away.
    // Without this, six infinite CSS animations keep compositing off-screen.
    this.anim = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.target.classList.toggle("is-live", e.isIntersecting)),
      { threshold: 0 }
    )
    this.element.querySelectorAll("[data-airb-anim]").forEach((el) => this.anim.observe(el))
  }

  disconnect() {
    this.io && this.io.disconnect()
    this.anim && this.anim.disconnect()
  }
}
